/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "GiftCardCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalCards",
                type: "uint256",
            },
        ],
        name: "GiftCardCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "claimer",
                type: "address",
            },
        ],
        name: "GiftCardUsed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "cancelGiftCard",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum GiftCard.Method",
                name: "method",
                type: "uint8",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                ],
                internalType: "struct GiftCard.VaultInfo[]",
                name: "vaults",
                type: "tuple[]",
            },
            {
                internalType: "address[]",
                name: "qualifiedWallets",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "totalCards",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "password",
                type: "string",
            },
        ],
        name: "createGiftCard",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "getGiftCardById",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum GiftCard.Method",
                        name: "method",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "createTime",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct GiftCard.VaultInfo[]",
                        name: "vaults",
                        type: "tuple[]",
                    },
                    {
                        internalType: "address[]",
                        name: "qualifiedWallets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256",
                        name: "totalCards",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "password",
                        type: "bytes32",
                    },
                ],
                internalType: "struct GiftCard.GiftCardInfo",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "getGiftCards",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum GiftCard.Method",
                        name: "method",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "createTime",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct GiftCard.VaultInfo[]",
                        name: "vaults",
                        type: "tuple[]",
                    },
                    {
                        internalType: "address[]",
                        name: "qualifiedWallets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256",
                        name: "totalCards",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "password",
                        type: "bytes32",
                    },
                ],
                internalType: "struct GiftCard.GiftCardInfo[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "string",
                name: "passphrase",
                type: "string",
            },
        ],
        name: "useGiftCard",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class GiftCard__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
GiftCard__factory.bytecode = _bytecode;
GiftCard__factory.abi = _abi;
